import { ref } from '@vue/composition-api'
import UserVendingSummaryApi from '@/api/admin/UserVendingSummary'
import UserSalesSummaryApi from '@/api/admin/UserSalesSummary'

// クロージング日計画面のユーザー別KPI（受領本数・売上）を取得・キャッシュする。
// 集計APIは重いため、初回のみ実取得し以降はキャッシュを使う（同一日想定）。
export default () => {
  const isLoading = ref(false)
  const isLoaded = ref(false)
  const vendingSummaries = ref([])
  const vendingHeaders = ref([])
  const salesSummaries = ref([])
  const salesHeaders = ref([])

  const fetch = async date => {
    if (isLoaded.value || isLoading.value) return
    isLoading.value = true
    try {
      const [vendingRes, salesRes] = await Promise.all([
        UserVendingSummaryApi.getUserVendingSummaries({ date, interval: 0, endDate: null }),
        UserSalesSummaryApi.getUserSalesSummaries({ date, interval: 0, endDate: null }),
      ])

      if (vendingRes?.data) {
        vendingSummaries.value = [...(vendingRes.data.userVendingSummaries || [])]
        vendingHeaders.value = [...(vendingRes.data.headers || [])]
      }
      if (salesRes?.data) {
        salesSummaries.value = [...(salesRes.data.userSalesSummaries || [])]
        salesHeaders.value = [...(salesRes.data.headers || [])]
      }

      isLoaded.value = true
    } finally {
      isLoading.value = false
    }
  }

  const buildRows = (headers, summary) => {
    if (!summary) return []

    return headers
      .map(header => ({ text: header.text, value: summary[header.value] }))
      .filter(row => row.value != null && Number(row.value) !== 0)
  }

  const kpiForUser = userId => {
    const vendingRow = vendingSummaries.value.find(summary => Number(summary.userId) === Number(userId))
    const salesRow = salesSummaries.value.find(summary => Number(summary.userId) === Number(userId))

    const vending = buildRows(vendingHeaders.value, vendingRow)
    const sales = buildRows(salesHeaders.value, salesRow)

    return {
      userName: vendingRow?.userName || salesRow?.userName || '',
      userRole: vendingRow?.userRole || salesRow?.userRole || '',
      vending,
      sales,
      vendingTotal: vending.reduce((acc, row) => acc + Number(row.value), 0),
      salesTotal: sales.reduce((acc, row) => acc + Number(row.value), 0),
    }
  }

  return {
    isLoading,
    isLoaded,
    fetch,
    kpiForUser,
  }
}
